import React, { Fragment } from 'react';
import { ProductItemV2 } from '../../../types/product';
import Img from '../../Img/Img';
import { setNumberWithComma } from '../../../lib/common';
import { PreviewSimpleProductCardStyle } from './style';

interface PreviewSimpleProductCardProps {
  className?: string;
  product: ProductItemV2;
}

const PreviewSimpleProductCard = (props: PreviewSimpleProductCardProps) => {
  const { className, product } = props;
  const { imageUrl, name, discountRate, salesPrice } = product;

  return (
    <PreviewSimpleProductCardStyle className={className}>
      <Img clickAble={false} src={imageUrl} />

      <div className="product-info">
        <div className="product-name">{name}</div>

        <div className="product-price-info">
          <span className="discount-price">
            {discountRate ? (
              <Fragment>
                {setNumberWithComma(discountRate)}
                <span className="unit">%</span>
              </Fragment>
            ) : null}
          </span>
          <span className="sales-price">
            {setNumberWithComma(salesPrice)}
            <span className="unit">원</span>
          </span>
        </div>
      </div>
    </PreviewSimpleProductCardStyle>
  );
};

export default PreviewSimpleProductCard;
